import {Variants} from 'framer-motion'

interface IAnimationVariants {
  injectSection: Variants
  topSection?: Variants
  leftSection?: Variants
  rightSection: Variants
  bottomSection: Variants
  soulBound?: Variants
  spirits?: Variants
  background?: Variants
}

export const originalVariants: IAnimationVariants = {
  background: {
    exit: {opacity: 0.8, transition: {duration: 0.7}},
  },
  topSection: {
    animate: {
      opacity: [0, 1, 1],
      top: ['50vh', '50vh', '18.5vh'],
      transition: {type: 'keyframes', duration: 2, times: [0, 0.6, 1]},
    },
    exit: {
      opacity: 0,
      transition: {duration: 0.7},
    },
  },
  spirits: {
    initial: {opacity: 0},
    animate: {
      opacity: 1,
      transition: {
        duration: 1,
        delay: 2.5,
      },
    },
    exit: {opacity: 0},
  },
  leftSection: {
    initial: {opacity: 0, left: '-50vw'},
    animate: {
      opacity: 1,
      left: 'auto',
      transition: {duration: 1, delay: 3, ease: 'easeInOut'},
    },
    exit: {
      opacity: 0,
      left: '-50vw',
      transition: {duration: 0.7, ease: 'easeInOut'},
    },
  },
  rightSection: {
    initial: {opacity: 0, left: '50vw'},
    animate: {
      opacity: 1,
      left: 'auto',
      transition: {duration: 1, delay: 3, ease: 'easeInOut'},
    },
    exit: {
      opacity: 0,
      left: '50vw',
      transition: {duration: 0.7, ease: 'easeInOut'},
    },
  },
  bottomSection: {
    initial: {opacity: 0, top: '110vh'},
    animate: {
      opacity: 1,
      top: '73.51vh',
      transition: {duration: 1, delay: 3, ease: 'easeInOut'},
    },
    exit: {
      opacity: 0,
      top: '110vh',
      transition: {duration: 0.7, ease: 'easeInOut'},
    },
  },
  injectSection: {
    initial: {opacity: 0},
    animate: {
      opacity: [0, 1, 0],
      transition: {duration: 2, delay: 4.5, repeat: Infinity, ease: 'linear'},
    },
  },
}

export const injectedVariants: IAnimationVariants = {
  topSection: {
    initial: {opacity: 0, top: '18.5vh'},
    animate: {
      opacity: 1,
      top: '18.5vh',
      transition: {duration: 1},
    },
    exit: {
      opacity: 0,
      transition: {duration: 0.7},
    },
  },
  spirits: {
    initial: {opacity: 0},
    animate: {
      opacity: 1,
      transition: {
        duration: 1,
      },
    },
    exit: {opacity: 0},
  },
  leftSection: {
    initial: {opacity: 0, left: '-50vw'},
    animate: {
      opacity: 1,
      left: 'auto',
      transition: {duration: 1, ease: 'easeInOut'},
    },
    exit: {
      opacity: 0,
      left: '-50vw',
      transition: {duration: 0.7, ease: 'easeInOut'},
    },
  },
  rightSection: {
    initial: {opacity: 0, left: '50vw'},
    animate: {
      opacity: 1,
      left: 'auto',
      transition: {
        duration: 1,
        ease: 'easeInOut',
      },
    },
    exit: {
      opacity: 0,
      left: '50vw',
      transition: {
        duration: 0.7,
        ease: 'easeInOut',
      },
    },
  },
  bottomSection: {
    initial: {opacity: 0, top: '110vh'},
    animate: {
      opacity: 1,
      top: '73.51vh',
      transition: {
        duration: 1,
        ease: 'easeInOut',
      },
    },
    exit: {
      opacity: 0,
      top: '110vh',
      transition: {
        duration: 0.7,
        ease: 'easeInOut',
      },
    },
  },
  injectSection: {
    initial: {opacity: 0},
    animate: {
      opacity: 1,
      transition: {duration: 1.5, delay: 1.5},
    },
    exit: {
      opacity: 0,
      transition: {duration: 0.3},
    },
  },
}

export const claimedVariants: IAnimationVariants = {
  background: {
    initial: {opacity: 0},
    animate: (opacity: number) => ({opacity, transition: {duration: 1.5}}),
    exit: {opacity: 0, transition: {duration: 0.7}},
  },
  spirits: {
    initial: {opacity: 0},
    animate: {
      opacity: 1,
      transition: {
        duration: 2,
      },
    },
    exit: {opacity: 0, transition: {duration: 0.7}},
  },
  soulBound: {
    initial: {opacity: 0},
    animate: {
      opacity: 1,
      transition: {duration: 1, delay: 1},
    },
    exit: {opacity: 0, transition: {duration: 0.7}},
  },
  leftSection: {
    initial: {opacity: 0, left: '-50vw'},
    animate: {
      opacity: 1,
      left: 'auto',
      transition: {duration: 1, delay: 2, ease: 'easeInOut'},
    },
    exit: {
      opacity: 0,
      left: '-50vw',
      transition: {duration: 0.7, ease: 'easeInOut'},
    },
  },
  rightSection: {
    initial: {opacity: 0, left: '50vw'},
    animate: {
      opacity: 1,
      left: 'auto',
      transition: {duration: 1, delay: 2, ease: 'easeInOut'},
    },
    exit: {
      opacity: 0,
      left: '50vw',
      transition: {duration: 0.7, ease: 'easeInOut'},
    },
  },
  bottomSection: {
    initial: {opacity: 0, top: '110vh'},
    animate: {
      opacity: 1,
      top: '76vh',
      transition: {duration: 1, delay: 2, ease: 'easeInOut'},
    },
    exit: {
      opacity: 0,
      top: '110vh',
      transition: {duration: 0.7, ease: 'easeInOut'},
    },
  },
  injectSection: {
    initial: {opacity: 0},
    animate: {
      opacity: 1,
      transition: {duration: 1.5, delay: 3},
    },
    exit: {
      opacity: 0,
      transition: {duration: 0.7},
    },
  },
}
